import React from 'react';
import { Page } from '../Page';
import { Target, Scale } from 'lucide-react';
export function Page2b() {
  return <Page pageNumber={7} variant="light" data-id="element-806" data-mp="xycoc72ocnw4">
      <div className="flex flex-col h-full" data-id="element-807" data-mp="xx9txp6583bg">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-808" data-mp="1cojxfw6skuk5">
          <img src="https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=1000&q=80" alt="Cooking and food preparation" className="w-full h-full object-cover object-center" data-id="element-809" data-mp="17pfpf8vlt2ve" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-810" data-mp="f1jqdxikayvg" />
        </div>

        <div className="mb-8" data-id="element-811" data-mp="t1m73gf4vm94">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-812" data-mp="oyplrhy7lc1h">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-813" data-mp="24eeygq40i8on">
            Calories, Carbs
            <br data-id="element-814" data-mp="20d34y9i0p3b6" />
            <span className="text-tealslate" data-id="element-815" data-mp="20dlajwqkktvr">and Fat</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-816" data-mp="3rd17ayu9bcqw" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-10" data-id="element-817" data-mp="7j8prh6afbw">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-818" data-mp="5yek2yrsyek">
            While protein, vitamins, omega-3s, and fiber form your foundation,
            you still need to understand the rest of your diet. You don't need
            to obsess over these numbers, but you do need to know how they work.
          </p>
          <div className="border-l-4 border-tealslate pl-6 py-3" data-id="element-819" data-mp="38lrtiddge1ti">
            <p className="text-base font-serif italic text-[#1F1F1F] leading-relaxed" data-id="element-820" data-mp="3cpzimbntpjs9">
              "Your body needs energy to function. GLP-1s reduce your appetite,
              but they don't change your biological need for fuel."
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-821" data-mp="2oykeqegeeuew">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-822" data-mp="2oxrdtu44ez4o">
            <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mb-4" data-id="element-823" data-mp="2tx3z4afcfy55">
              <Target className="w-5 h-5 text-tealslate" data-id="element-824" data-mp="3saj1gj753ksw" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-825" data-mp="3s8f1udg9x7yf">Calories</h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-826" data-mp="9w0fjb23mhch">
              When your medication dose is appropriate, you are already in a
              calorie deficit. Tracking becomes useful when progress stalls or
              when preparing to transition off medication.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-827" data-mp="39dhu4rq458ls">
            <div className="w-10 h-10 rounded-full bg-navyslate/40 border border-navyslate/60 flex items-center justify-center mb-4" data-id="element-828" data-mp="3nchidy9prlhf">
              <Scale className="w-5 h-5 text-tealslate" data-id="element-829" data-mp="3ieg1njzrfy94" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-830" data-mp="12jwbuenra78q">
              Carbs and Fat
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-831" data-mp="xlur7paolzv5">
              Carbohydrates regulate themselves when meals are built around
              protein and fiber-rich foods. Fat is essential for hormones and
              brain function, but most protein sources naturally provide it.
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-832" data-mp="113s5ixhjol4m">
          <p className="text-sm text-[#3B3B3B] leading-[1.8] border-l-2 border-[#D8D8D0] pl-6" data-id="element-833" data-mp="114k2abmvoowh">
            Tracking can be a helpful habit, but it is not required for success
            on GLP-1 medication. If you choose to track, use it as a tool. If
            you do not, focus on the foundational habits that drive results.
          </p>
        </div>
      </div>
    </Page>;
}